export default __webpack_public_path__ + "static/teamPhoto1-387d948cc6d12284ca77fb8196bf7b23.png";